export function uploadFileWebSiteApi(request, data: FormData) {
  return request({
    url: "zh-business/api/v1/upload/file",
    method: "POST",
    data
  }).then(res => res.data);
}
export function uploadBiddingFileApi(request, data: FormData) {
  return request({
    url: "zh-business/client/v1/bidding/apply/upload/file",
    method: "POST",
    data
  }).then(res => res.data);
}
export function uploadFileApi(request, data: FormData) {
  return request({
    url: "zh-business/api/v1/upload/picture/file",
    method: "POST",
    data
  }).then(res => res.data);
}
export function uploadCustomFile(request, data: FormData) {
  return request({
    url: "zh-business/console/v1/bidding/project/upload/file",
    method: "POST",
    data
  }).then(res => res.data);
}
export function uploadVideoApi(request, data: FormData) {
  return request({
    url: "zh-business/api/v1/upload/video/file",
    method: "POST",
    data
  }).then(res => res.data);
}
export function previewFileApi(request, data: string) {
  return request({
    url: "zh-business/api/v1/upload/file",
    method: "GET",
    params: { path: data }
  }).then(res => res.data);
}

export function getImgPathApi(request, data) {
  return request({
    url: "zh-business/api/v1/file/path/list",
    method: "post",
    data
  });
}

export function downFileApi(request, id: string | number) {
  return request({
    url: "zh-business/console/v1/supplier/download/file",
    method: "get",
    params: {
      id
    }
  })
}
